module.exports = __webpack_public_path__ + "img/management.f75e8d62.gif";